import fetch from "@/utils/fetch";

// zym.基本信息
export function initBase(params) {
  return fetch({
    url: "eavar/static-data-gen/initBase",
    method: "post",
    data: params,
  });
}

// zym.基本信息  - 连续型出版物
export function initLxdzBase(params) {
  return fetch({
    url: "eavar/static-data-gen/initLxdzBase",
    method: "post",
    data: params,
  });
}

// zym.经营情况
export function initFinance(params) {
  return fetch({
    url: "eavar/static-data-gen/initFinance",
    method: "post",
    data: params,
  });
}

// zym.经营情况  - 连续型出版物
export function initLxdzFinance(params) {
  return fetch({
    url: "eavar/static-data-gen/initLxdzFinance",
    method: "post",
    data: params,
  });
}

// zym.出版物
export function initPublication(params) {
  return fetch({
    url: "eavar/static-data-gen/initPublication",
    method: "post",
    data: params,
  });
}

// zym.人员情况
export function initWorker(params) {
  return fetch({
    url: "eavar/static-data-gen/initWorker",
    method: "post",
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/pgMent/sectStatic.js